import React, { useState, useEffect } from 'react';
import './Pagination.scss';

const Pagination = ({ totalData, currentPage, numberOfRowOnPage, pageHandler }) => {
  const [currentPageStart, setCurrentPageStart] = useState(1);
  const [currentPageEnd, setCurrentPageEnd] = useState(numberOfRowOnPage);
  const [numberOfPages, setNumberOfPages] = useState(totalData / numberOfRowOnPage);

  useEffect(() => {
    if (currentPage === 1) {
      setCurrentPageStart(currentPage);
      setCurrentPageEnd(currentPage * numberOfRowOnPage);
    } else {
      setCurrentPageStart(currentPage * numberOfRowOnPage - numberOfRowOnPage + 1);
      setCurrentPageEnd(currentPage * numberOfRowOnPage);
    }
  }, [currentPage, numberOfRowOnPage]);

  const nextBtnHandler = () => {
    const totalPageCount = Math.ceil(totalData / numberOfRowOnPage);

    if (totalPageCount !== currentPage) {
      pageHandler(currentPage + 1);
    }
  };

  const prevBtnHandler = () => {
    if (currentPage > 1) {
      pageHandler(currentPage - 1);
    }
  };

  return (
    <div className="gridjs-footer">
      <div className="gridjs-pagination">
        <div className="gridjs-summary">
          Showing <b>{currentPageStart}</b> to <b>{currentPageEnd}</b> of <b>{totalData}</b> results
        </div>
        <div className="gridjs-pages" style={{ display: 'flex' }}>
          <button disabled={currentPage === 1} onClick={prevBtnHandler}>
            Previous
          </button>

          <div className="pagination_txt_container">
            {Array.from({ length: numberOfPages }, (_, i) => i + 1).map((_, index) => {
              return (
                <button key={index} className={`${currentPage === index + 1 && 'gridjs-currentPage'}`} onClick={() => pageHandler(index + 1)}>
                  {index + 1}
                </button>
              );
            })}
          </div>

          <button disabled={Math.ceil(totalData / numberOfRowOnPage) === currentPage} onClick={nextBtnHandler}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
